module.exports = __webpack_public_path__ + "static/media/background_img.2569bfdb.jpg";